import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { decodeGetter } from '@/app/common/components/ag-grid/configs';
import RankChangeRenderer from '@/app/common/components/CellRenderers/RankChangeRenderer';
import RankRenderer from '@/app/common/components/CellRenderers/RankRenderer';

import { trackerTooltips } from '@/app/KeywordTracker/tooltip/trackerTooltips';
import { FaDesktop, FaMobileScreenButton } from 'react-icons/fa6';
import numberHumanizer from '@/helpers/numberHumanizer';
import HelpTooltip from '@/app/common/components/HelpTooltip';
import { commonTooltips } from '@/app/common/tooltip/commonTooltips';
import { useDispatch } from 'react-redux';
import ChildrensTooltip from '@/components/common/ChildrensTooltip';
import SmallButton from '@/app/common/components/SmallButton';
import DomainFavicon from '@/app/common/components/DomainFavicon';
import { showDrawer } from '@/app/common/reducers/drawer';

export const competitorsColumnConfig = (columns, isMdUp) => {
  let mapCoumns = [
    {
      field: 'title',
      type: 'string',

      title: 'کلمه کلیدی',
      width: 300,
      pinned: isMdUp && 'right',
      searchable: true,
      filterValueGetter: decodeGetter,
      cellRenderer: params => {
        let keywordDecoded;
        try {
          keywordDecoded = decodeURIComponent(params.value);
        } catch (err) {
          keywordDecoded = params.value;
        }
        return (
          <>
            {keywordDecoded}
            {params.data.device_type === 1 ? (
              <FaDesktop className="mx-1" title="mobile" />
            ) : (
              <FaMobileScreenButton className="mx-1" title="mobile" />
            )}
            <span className="border border-1 fs--2 rounded-2 py-0 px-1">
              {params?.data?.location}
            </span>
          </>
        );
      }
    },
    {
      field: 'search_volume_miztols',
      tooltip: trackerTooltips.mainGrid.columns.mizfa_tools_search_volume,
      type: 'number',
      title: 'میزان جستجو',
      width: 142,
      searchable: false,
      cellRenderer: params => {
        return (
          <>
            {!params.value ? (
              <HelpTooltip html={commonTooltips.searchVolume} />
            ) : (
              <div className="d-flex align-items-center gap-1">
                {numberHumanizer(params.value)}
              </div>
            )}
          </>
        );
      }
    },
    {
      field: 'actions',
      type: 'array',
      sortable: false,
      title: 'عملیات',
      width: 80,
      pinned: 'left',
      searchable: false,
      noFilter: true,
      cellRenderer: params => {
        const dispatch = useDispatch();
        return (
          <>
            <div className="d-flex h-100 justify-content-center align-items-center gap-2">
              <ChildrensTooltip
                showOnHover={false}
                delayToRemove={50}
                placement="top"
                html={'میانگین رتبه'}
              >
                <SmallButton
                  onClick={() => {
                    dispatch(
                      showDrawer({
                        key: 'competitors_rank',
                        payload: {
                          keyword_id: params.data.id,
                          keyword: params.data.title
                        }
                      })
                    );
                  }}
                >
                  <FontAwesomeIcon fontSize="11px" icon="chart-line" />
                </SmallButton>
              </ChildrensTooltip>
            </div>
          </>
        );
      }
    }
  ];

  columns?.map(item => {
    mapCoumns.push({
      field: item,
      valueGetter: params => params?.data[item]?.rate,
      gp: item,
      gpicon: (
        <DomainFavicon domain={item} width={18} className="rounded-circle mb-n1" />
      ),
      suppressHeaderMenuButton: true,
      sortable: true,
      title: 'رتبه',
      flex: 1,
      type: 'number',
      minWidth: 100,
      searchable: false,
      cellRenderer: params => {
        return <RankRenderer rank={params?.data[item]?.rate} />;
      }
    });

    mapCoumns.push({
      field: item,
      valueGetter: params => params?.data[item]?.change_rank,
      suppressHeaderMenuButton: true,
      gp: item,
      sortable: true,
      flex: 1,
      type: 'number',
      minWidth: 100,
      title: 'تغییر',
      searchable: true,
      cellRenderer: params => {
        return <RankChangeRenderer change={params?.data[item]?.change_rank} />;
      }
    });
  });

  return mapCoumns;
};
